var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4109",
    "data-name": "\\uADF8\\uB8F9 4109",
    transform: "translate(-864 -677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4108",
    "data-name": "\\uADF8\\uB8F9 4108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3755",
    "data-name": "\\uADF8\\uB8F9 3755",
    transform: "translate(813 -322)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_111",
    "data-name": "\\uD0C0\\uC6D0 111",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(51 999)",
    fill: "#e7e9ef"
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\uC5C5\\uCCB4",
    transform: "translate(71 1023.5)",
    fill: "#004672",
    fontSize: 14,
    fontFamily: "AppleSDGothicNeo-Regular, Apple SD Gothic Neo"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12,
    y: 0
  }, "\uC5C5\uCCB4")))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbCompany);
export default __webpack_public_path__ + "static/media/thumbCompany.20ae1299e2f98ce744e31a92579faf94.svg";
export { ForwardRef as ReactComponent };